import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MMEApi } from '../../../apis/MMEApi/MMEApi.ts';
import { ISaveMMECalculationRequest } from '../MME.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { AppMedError } from '../../../error/AppMedError.ts';

export function useSaveMMECalculation() {
    const queryClient = useQueryClient();

    return useMutation<number, AppMedError, ISaveMMECalculationRequest>({
        mutationKey: [QueryKeys.mmeSavedCalculations],
        mutationFn: async (request: ISaveMMECalculationRequest) => {
            return await MMEApi.saveCalculation(request);
        },
        onSuccess: (_, variables) => {
            // Invalidate saved calculations query to refresh the list
            queryClient.invalidateQueries({ 
                queryKey: [QueryKeys.mmeSavedCalculations, variables.patientID] 
            });
        },
    });
}

